import React from 'react';
import styled from 'styled-components';
import { useStoreState } from 'easy-peasy';
import swal from 'sweetalert';
// import moment from 'moment-timezone';
// import { isNaN } from 'lodash';

import { useTableBookingsDetails } from './helpers';

import Ballon from './Ballon';

import Birthday from './Birthday';
import { useUpdateTableBooking } from '../AddModifyBooking/helpers';
import { useTableSetting } from '../TableBookingSetting/helpers';

const TableItem = styled.div`
  border: 1px solid #e2e2e2;
  font-size: 14px;
  color: black;
  padding: 10px;
  text-align: center;
  background-color: ${({ isAlternate }) =>
    isAlternate ? '#EEEEEE' : '#FFFFFF'};
`;

// const GridItem3 = styled.div`
//   display: grid;
//   grid-template-columns: 1fr;
//   width: 100%;
//   gap: 0;
//   padding: 0 2rem;
// `;

// const LeftSpan = styled.span`
//   color: #737373;
// `;

// font-weight: 700;

const RightSpan = styled.span``;

// const BookingDetailsItem = styled.div`
//   display: grid;
//   grid-template-columns: 0.75fr 1.25fr;
//   width: 100%;
//   gap: 2rem 0;
//   padding: 2rem;
// `;

const statusColorDict = {
  UPCOMING: '#FF9900',
  CHECKEDIN: 'green',
  SEATED: '#00AEEF',
  WAITLISTED: '#EE2A7B',
  'NO SHOW': 'red',
  RECEIVED: 'green',
  CONFIRMED: '#00AEEF',
  CANCELLED: 'red',
};

const statusStyles = color => ({
  color: color ? statusColorDict[color] : '#505050',
  fontWeight: '600',
});

const TableItems = ({ tab, ele, placeId, history, idx }) => {
  const { userId: adminUserId } = useStoreState(state => state.auth);

  const [
    ,
    tableBookingDetails,
    refetchTableBookingsDetails,
  ] = useTableBookingsDetails({
    adminUserId,
    tableBookingId: ele.table_booking_id,
    placeId,
  });

  const [tableSetting, ,] = useTableSetting({ placeId });

  const shldShowConfirmButton =
    (tab === 0 || tab === 1) &&
    tableBookingDetails?.booking_status === 'RECEIVED';

  const shldShowSeatButton =
    (tab === 0 || tab === 1 || tab === 2) &&
    tableBookingDetails?.booking_status === 'CONFIRMED' &&
    tableBookingDetails?.guest_status === 'UPCOMING';

  const shldShowGuestStatus = tableBookingDetails?.guest_status !== 'UPCOMING';

  const [, updateTableBooking, , ,] = useUpdateTableBooking();

  const onChangeBookingStatus = async bookingStatus => {
    await updateTableBooking({
      user_id: adminUserId,
      table_booking_id: tableBookingDetails.table_booking_id,
      booking_status: bookingStatus,
    });

    await refetchTableBookingsDetails();
  };

  const onChangeGuestStatus = async guestStatus => {
    await updateTableBooking({
      user_id: adminUserId,
      table_booking_id: tableBookingDetails.table_booking_id,
      guest_status: guestStatus,
    });

    await refetchTableBookingsDetails();
  };

  return (
    <>
      <TableItem
        isAlternate={idx % 2 === 1}
        style={{ fontSize: '16px', cursor: 'pointer' }}
        onClick={() =>
          history.push(`/add-modify-booking/${placeId}/${ele.table_booking_id}`)
        }
      >
        <div className="is-flex is-flex-direction-row">
          <div className="is-flex-direction-column">
            <div
              className="has-text-left"
              style={{ color: 'rgb(72, 95, 199)' }}
            >
              {ele.booking_reference}
            </div>
            <div className="has-text-left">{ele.booking_time}</div>
            <div className="has-text-left">{ele.booking_date}</div>
          </div>
          <div className="m-4">
            {Array.isArray(ele.tags) &&
              !!ele.tags.find(ele2 => ele2 === 'Anniversary') && <Ballon />}
            {Array.isArray(ele.tags) &&
              !!ele.tags.find(ele2 => ele2 === 'Birthday') && <Birthday />}
          </div>
        </div>
      </TableItem>
      <TableItem
        isAlternate={idx % 2 === 1}
        style={{ fontSize: '16px', cursor: 'pointer' }}
        onClick={() =>
          history.push(`/add-modify-booking/${placeId}/${ele.table_booking_id}`)
        }
      >
        <div className="is-flex-direction-column">
          <div>
            {ele.guest_count}{' '}
            {tableBookingDetails?.table_number
              ? `(${tableBookingDetails?.table_number})`
              : ''}
          </div>
        </div>
      </TableItem>
      <TableItem
        isAlternate={idx % 2 === 1}
        style={{ cursor: 'pointer' }}
        onClick={() =>
          history.push(`/add-modify-booking/${placeId}/${ele.table_booking_id}`)
        }
      >
        <div className="is-flex-direction-column">
          <div className="has-text-left" style={{ fontSize: '16px' }}>
            {ele.contact.first_name} {ele.contact.last_name}
          </div>
          {tableBookingDetails?.guest_notes && (
            <div
              className="has-text-left"
              style={{ color: '#505050', fontWeight: '500', fontSize: '14px' }}
            >
              {tableBookingDetails.guest_notes}
            </div>
          )}
          {tableBookingDetails?.restaurant_notes && (
            <div
              className="has-text-left"
              style={{ color: '#EE2A7B', fontWeight: '500', fontSize: '14px' }}
            >
              {tableBookingDetails.restaurant_notes}
            </div>
          )}
        </div>
      </TableItem>
      <TableItem
        isAlternate={idx % 2 === 1}
        style={{ fontSize: '16px', cursor: 'pointer' }}
        onClick={() =>
          history.push(`/add-modify-booking/${placeId}/${ele.table_booking_id}`)
        }
      >
        {tableBookingDetails?.billing?.sub_total && (
          <>
            {/* <LeftSpan>
              
              </LeftSpan> */}
            <div className="is-flex-direction-column">
              <div className="has-text-center">
                <RightSpan>
                  $
                  {parseFloat(tableBookingDetails?.billing?.sub_total).toFixed(
                    2,
                  )}
                </RightSpan>
              </div>
              <div className="has-text-center">
                <RightSpan>
                  {tableBookingDetails?.guest_count &&
                    tableSetting?.booking_fee?.booking_fee_info
                      ?.booking_deposit &&
                    tableSetting?.booking_fee?.booking_fee_info
                      ?.booking_type === 'FEE_PER_GUEST' && (
                      <>
                        <>
                          {tableSetting?.booking_fee?.booking_fee_info
                            ?.apply_deposit_to_bill
                            ? 'Deposit'
                            : 'Fee'}
                        </>{' '}
                        {tableBookingDetails?.guest_count &&
                        tableSetting?.booking_fee?.booking_fee_info
                          ?.booking_deposit &&
                        tableSetting?.booking_fee?.booking_fee_info
                          ?.booking_type === 'FEE_PER_GUEST'
                          ? ` $${parseFloat(
                              tableSetting?.booking_fee?.booking_fee_info
                                ?.booking_deposit,
                            )} x ${tableBookingDetails?.guest_count}`
                          : ''}
                      </>
                    )}
                </RightSpan>
              </div>
            </div>
          </>
        )}

        {/* <BookingDetailsItem> */}
        {/* {tableBookingDetails?.billing?.sub_total && (
            <>
              <LeftSpan>Subtotal</LeftSpan>
              <RightSpan>
                $
                {parseFloat(tableBookingDetails?.billing?.sub_total).toFixed(2)}
              </RightSpan>
            </>
          )}
          {Array.isArray(tableBookingDetails?.billing?.charges_list) &&
            tableBookingDetails?.billing?.charges_list
              .filter(
                chg =>
                  !chg.is_payment_gateway_fee &&
                  chg.is_payment_gateway_fee !== null,
              )
              .filter(chg => {
                const tempValue = parseFloat(chg.value);
                return tempValue !== 0 && !isNaN(tempValue);
              })
              .map(chg => (
                <React.Fragment key={chg.name}>
                  <LeftSpan>{chg.name}</LeftSpan>
                  <RightSpan>${parseFloat(chg.value).toFixed(2)}</RightSpan>
                </React.Fragment>
              ))}
          {!!tableBookingDetails?.billing?.payment_gateway_fee && (
            <>
              <LeftSpan>Card Processing Fee</LeftSpan>
              <RightSpan>
                $
                {parseFloat(
                  tableBookingDetails?.billing?.payment_gateway_fee,
                ).toFixed(2)}
              </RightSpan>
            </>
          )}
          <LeftSpan>Booking Total</LeftSpan>
          <RightSpan>
            $
            {parseFloat(tableBookingDetails?.billing?.booking_total).toFixed(2)}
          </RightSpan> */}
        {/* </BookingDetailsItem> */}
        {/* {tableBookingDetails?.payment?.payment_at &&
          tableBookingDetails?.payment?.payment_card?.brand &&
          tableBookingDetails?.payment?.payment_card?.last4 && (
            <GridItem3>
              <p className="is-size-4 has-text-weight-semibold">
                Paid: $
                {parseFloat(
                  tableBookingDetails?.billing?.booking_total,
                ).toFixed(2)}{' '}
                on{' '}
                {moment(tableBookingDetails?.payment?.payment_at).format(
                  'ddd, MMM DD, YYYY hh:mm A',
                )}
              </p>
              <p>
                {tableBookingDetails?.payment?.payment_card?.brand} ending in{' '}
                {tableBookingDetails?.payment?.payment_card?.last4}
              </p>
            </GridItem3>
          )} */}
      </TableItem>
      <TableItem
        isAlternate={idx % 2 === 1}
        style={{ fontSize: '16px', cursor: 'pointer' }}
      >
        <div className="is-flex-direction-column">
          <div className="has-text-center" style={{ marginBottom: '1rem' }}>
            <a href={`tel:+${ele.contact.contact_phone}`}>
              {ele.contact.contact_phone}
            </a>
          </div>
          <div
            className="has-text-center"
            style={{
              marginBottom: '1rem',
            }}
          >
            {ele.contact.contact_email}
          </div>
        </div>
      </TableItem>
      <TableItem isAlternate={idx % 2 === 1} style={{ fontSize: '16px' }}>
        <div className="is-flex is-flex-direction-column is-justify-content-center is-align-items-center">
          <div
            style={{
              ...statusStyles(tableBookingDetails?.booking_status),
              marginBottom: '1.5rem',
              marginRight: '1rem',
            }}
          >
            {tableBookingDetails?.booking_status}
          </div>
          {shldShowGuestStatus && (
            <div
              className="has-text-center"
              style={{
                ...statusStyles(tableBookingDetails?.guest_status),
                marginBottom: '1.5rem',
              }}
            >
              {tableBookingDetails?.guest_status}
            </div>
          )}
          {shldShowConfirmButton && (
            <button
              type="button"
              className="button is-rounded is-primary"
              onClick={() => {
                swal({
                  text: 'Would you like to CONFIRM this table booking?',
                  buttons: ['Cancel', 'OK'],
                }).then(res => {
                  if (res) {
                    onChangeBookingStatus('CONFIRMED');
                  }
                });
              }}
              style={{
                marginBottom: '1.5rem',
                width: '4rem',
                fontSize: '0.75rem',
                marginRight: '0.5rem',
              }}
            >
              Confirm
            </button>
          )}
          {shldShowSeatButton && (
            <button
              type="button"
              className="button is-rounded is-primary"
              onClick={() => {
                swal({
                  text: 'Would you like to SEAT this table booking?',
                  buttons: ['Cancel', 'OK'],
                }).then(res => {
                  if (res) {
                    onChangeGuestStatus('SEATED');
                  }
                });
              }}
              style={{
                marginBottom: '1.5rem',
                width: '4rem',
                fontSize: '0.75rem',
                marginRight: '0.5rem',
              }}
            >
              Seat
            </button>
          )}
        </div>
      </TableItem>
    </>
  );
};

export default TableItems;
